import {
  Label as LabelType,
  LabelVisibility,
} from '@aibees/elephant/types/label';
import { Icon, Label, TextEllipsis } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Checkbox } from '@mui/material';
import React, { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { AddListToInputCheckboxProps as Props } from './types';

export const AddListToInputCheckbox = memo(
  ({ className, item, onChange, disabled }: Props) => {
    const handleChange = (
      event: React.ChangeEvent<HTMLInputElement>,
      l: LabelType
    ) => {
      onChange?.(event.target.checked, l);
    };

    return (
      <Styled.Wrapper
        className={classnames('AddListToInputCheckbox', className)}
        sx={SX.root}
      >
        <Checkbox
          defaultChecked={true}
          onChange={(e) => handleChange(e, item)}
          size="small"
          disabled={disabled}
        />
        <TextEllipsis variant="body4" fontWeight={500} color="grey.600">
          {item.name}
        </TextEllipsis>

        {item.visibility === LabelVisibility.PRIVATE && (
          <Label size="xsmall">
            <Icon name="lock-rounded" size={8} />
          </Label>
        )}
      </Styled.Wrapper>
    );
  }
);

AddListToInputCheckbox.displayName = 'AddListToInputCheckbox';
